import { useNavigate } from 'react-router-dom';

export function TopUpButton() {
  const navigate = useNavigate();

  return (
    <button
      className="text-[#A1F69E] text-lg font-medium 
             hover:text-[#A1F69E]/30 
             transition-all duration-200 
             flex items-center justify-center gap-1 
             active:scale-95 font-raleway"
      onClick={() => {
        setTimeout(() => navigate('/makepayment'), 350);
      }}
    >
      Пополнить счёт
      <svg
        className="transition-transform group-hover:translate-x-1"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
